(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["header-dropdown-menu"] && !Shopify.designMode) return;
  try {
    (()=>{
 const initialize=()=>document.querySelectorAll('.lb-categories').forEach(nav=>{
  if(nav.dataset.lbReady)return;
  nav.dataset.lbReady='true';
  const hover=matchMedia('(min-width:990px) and (hover:hover) and (pointer:fine)');
  const root=nav.querySelector('.lb-category-root');
  const close=d=>{d.open=false;d.querySelector(':scope > summary')?.setAttribute('aria-expanded','false');d.querySelectorAll('details').forEach(x=>{x.open=false;x.querySelector(':scope > summary')?.setAttribute('aria-expanded','false')})};
  const position=d=>{
   const panel=d.querySelector(':scope > .header__submenu');if(!panel)return;
   const parent=d.closest('ul').getBoundingClientRect();
   const row=d.querySelector(':scope > summary').getBoundingClientRect();
   const x=parent.right+290>innerWidth-12?Math.max(12,parent.left-290):parent.right-1;
   const y=Math.max(12,Math.min(row.top,innerHeight-220));
   panel.style.setProperty('--lb-flyout-x',x+'px');panel.style.setProperty('--lb-flyout-y',y+'px');panel.style.setProperty('--lb-flyout-height',(innerHeight-y-24)+'px');
  };
  nav.querySelectorAll('details').forEach(d=>{
   let timer;
   d.addEventListener('pointerenter',()=>{if(!hover.matches)return;clearTimeout(timer);const parent=d.closest('ul');if(parent)parent.querySelectorAll(':scope > li > header-menu > details,:scope > li > details').forEach(s=>{if(s!==d)close(s)});position(d);d.open=true;d.querySelector(':scope > summary')?.setAttribute('aria-expanded','true')});
   d.addEventListener('pointerleave',()=>{if(!hover.matches)return;timer=setTimeout(()=>{if(!d.contains(document.activeElement))close(d)},250)});
   d.addEventListener('toggle',()=>{if(d.open)position(d);d.querySelector(':scope > summary')?.setAttribute('aria-expanded',String(d.open))});
  });
  nav.addEventListener('keydown',e=>{if(e.key==='Escape'){e.preventDefault();close(root);root.querySelector('summary').focus()}});
  document.addEventListener('click',e=>{if(!nav.contains(e.target))close(root)});
  window.addEventListener('resize',()=>close(root));
  root.querySelector(':scope > ul').addEventListener('scroll',()=>root.querySelectorAll('details[open]').forEach(position));
 });
 initialize();document.addEventListener('shopify:section:load',initialize);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["lebbuy-announcement-compact"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('lebbuy-announcements')) {
  customElements.define('lebbuy-announcements', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.index = 0;
      this.slides = [...this.querySelectorAll('.lebbuy-announcements__item')];
      this.narrow = matchMedia('(max-width:1199px)');
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.paused = this.motion.matches;
      this.pauseButton = this.querySelector('[data-pause]');
      this.querySelector('[data-prev]').addEventListener('click', () => this.step(-1, true));
      this.querySelector('[data-next]').addEventListener('click', () => this.step(1, true));
      this.pauseButton.addEventListener('click', () => { this.paused = !this.paused; this.update(); });
      this.addEventListener('mouseenter', () => { this.hovering = true; });
      this.addEventListener('mouseleave', () => { this.hovering = false; });
      this.onResize = () => this.update();
      this.narrow.addEventListener('change', this.onResize);
      this.dataset.ready = '';
      this.update();
      this.timer = setInterval(() => {
        if (this.narrow.matches && !this.paused && !this.hovering && !this.contains(document.activeElement) && !document.hidden) this.step(1, false);
      }, 6000);
    }
    step(delta, manual) {
      this.index = (this.index + delta + this.slides.length) % this.slides.length;
      if (manual) this.paused = true;
      this.update();
    }
    update() {
      this.slides.forEach((slide, i) => {
        const visible = !this.narrow.matches || i === this.index;
        slide.toggleAttribute('data-active', i === this.index);
        slide.setAttribute('aria-hidden', String(!visible));
        if (slide.matches('a')) slide.tabIndex = visible ? 0 : -1;
      });
      this.pauseButton.setAttribute('aria-pressed', String(this.paused));
      this.pauseButton.setAttribute('aria-label', this.paused ? this.dataset.playLabel : this.dataset.pauseLabel);
    }
    disconnectedCallback() {
      clearInterval(this.timer);
      this.narrow?.removeEventListener('change', this.onResize);
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["lebbuy-express-delivery"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('lebbuy-express')) {
  customElements.define('lebbuy-express', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      const details = this.querySelector('details');
      const trigger = this.querySelector('summary');
      const panel = this.querySelector('.lb-express__panel');
      let pointerFocus = false;
      let openedByHover = false;
      let suppressFocus = false;
      const place = () => {
        panel.style.marginInlineStart = '';
        const r = panel.getBoundingClientRect();
        const delta = r.left < 12 ? 12 - r.left : r.right > innerWidth - 12 ? innerWidth - 12 - r.right : 0;
        panel.style.marginInlineStart = (getComputedStyle(this).direction === 'rtl' ? -delta : delta) + 'px';
      };
      const open = () => { details.open = true; trigger.setAttribute('aria-expanded', 'true'); place(); };
      const close = (restore = false) => {
        details.open = false;
        openedByHover = false;
        trigger.setAttribute('aria-expanded', 'false');
        if (restore) { suppressFocus = true; trigger.focus(); suppressFocus = false; }
      };
      trigger.setAttribute('aria-expanded', 'false');
      this.addEventListener('pointerenter', e => { if (e.pointerType === 'mouse' && matchMedia('(hover:hover)').matches && !details.open) { openedByHover = true; open(); } }, options);
      this.addEventListener('pointerleave', e => { if (e.pointerType === 'mouse' && !this.contains(document.activeElement)) close(); }, options);
      trigger.addEventListener('click', e => { if (openedByHover) { e.preventDefault(); openedByHover = false; open(); } }, options);
      trigger.addEventListener('pointerdown', () => { pointerFocus = true; }, options);
      trigger.addEventListener('pointerup', () => { pointerFocus = false; }, options);
      trigger.addEventListener('pointercancel', () => { pointerFocus = false; }, options);
      this.addEventListener('focusin', () => { if (!pointerFocus && !suppressFocus) open(); }, options);
      this.addEventListener('focusout', e => { if (!this.contains(e.relatedTarget)) close(); }, options);
      details.addEventListener('toggle', () => { trigger.setAttribute('aria-expanded', String(details.open)); if (details.open) place(); }, options);
      this.querySelector('button').addEventListener('click', () => close(true), options);
      document.addEventListener('pointerdown', e => { if (!this.contains(e.target)) close(); }, options);
      this.addEventListener('keydown', e => { if (e.key === 'Escape') { e.preventDefault(); e.stopPropagation(); close(true); } }, options);
      window.addEventListener('resize', () => close(), options);
    }
    disconnectedCallback() { this.controller?.abort(); }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["lebbuy-language-selector"] && !Shopify.designMode) return;
  try {
    document.addEventListener('keydown',event=>{
 if(event.key!=='Escape')return;
 const selector=event.target.closest('.lb-language[open]');
 if(selector){selector.open=false;selector.querySelector('summary').focus();event.stopPropagation()}
});
document.addEventListener('click',event=>{
 document.querySelectorAll('.lb-language[open]').forEach(selector=>{if(!selector.contains(event.target))selector.open=false});
});
  } catch(e) { console.error(e); }
})();

})();
